import { useEffect } from "../../../../libs/react";
export var usePreventScrolling = function usePreventScrolling(isOpen) {
  useEffect(function () {
    if (isOpen) {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = "".concat(scrollbarWidth, "px"); // Prevent shift
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
    return function () {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);
};